export const apiCacheTags = {
  eval: {
    limits: "EvalLimits",
    testCases: "EvalTestCases",
    thresholds: "EvalThresholds",
  },
  analytics: {
    datasetStats: "AnalyticsDatasetStats",
  },
  confidenceReport: {
    report: "ConfidenceReport",
  },
} as const;
